import { Login } from 'js/models'
import { makeCamelCase, setRefresh, setToken } from 'js/utils/helpers'
import api, { FormError } from './api'

/*=============================================
=                     GET                     =
=============================================*/

/*=============================================
=                    POST                     =
=============================================*/
export const SignIn = (
  email: string,
  password: string
): Promise<void | FormError<Login>> => {
  const data = { email: email.toLocaleLowerCase(), password: password }

  return api
    .post('/auth/login/', data)
    .then(r => {
      setToken(r.data.access)
      setRefresh(r.data.refresh)
    })
    .catch(e => {
      e.formErrors = makeCamelCase(e.response.data)
      return Promise.reject(e)
    })
}

export const createPasswordReset = (email: string): Promise<string> => {
  const data = { email: email.toLocaleLowerCase() }
  return api.post('/auth/password/reset/', data).then(r => r.data.detail)
}

export const SignOut = (): void => {
  const refresh = localStorage.getItem('refresh')
  api.post('/auth/logout/', { refresh }).finally(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh')
    window.open('/', '_self')
  })
}

/*=============================================
=                    PATCH                    =
=============================================*/
